module.exports = __webpack_public_path__ + "static/media/banner-size-1.f9eab99c.webp";